import { useSelector } from "react-redux";


const useUserIsAllowed = (tag) =>{
    const {permissions, is_admin} = useSelector(state=> state.userReducer.value);
    const isAllowed = permissions?.find(el=> el?.guard_name === tag);

    const data = (isAllowed || is_admin) ? true : false

    return data;
}

export default useUserIsAllowed;